import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import css from './styles.module.scss';
import { Box, Typography } from '@material-ui/core';
import { BoxProps } from '@material-ui/core/Box/Box';
import { Pagination } from '@material-ui/lab';
import { v4 as uuidV4 } from 'uuid';

type Props = BoxProps & {
    data: any[];
    renderItem(item: any, index: number): JSX.Element;
    itemsPerPage?: number;
    keyName?: string;
    grid?: 2 | 3 | 4;
    hideTotal?: boolean;
    centeredPagination?: boolean;
};

export const PaginatedBlock: React.FC<Props> = ({
    className,
    data,
    renderItem,
    itemsPerPage = 10,
    keyName,
    grid,
    hideTotal = false,
    centeredPagination = false,
    ...props
}) => {
    const [currentPage, setCurrentPage] = useState(1);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
    const pagesCount = Math.ceil(data.length / itemsPerPage);

    useEffect(() => {
        setCurrentPage(1);
    }, [data]);

    return (
        <Box className={classNames(css.module, grid && css[`grid${grid}`], className)} {...props}>
            {currentItems.map((item ) => renderItem(item, (keyName && item[keyName]) || uuidV4()))}
            {data.length > itemsPerPage && (
                <Box className={classNames(css.paginationWrapper, centeredPagination && css.centeredPagination)}>
                    {!hideTotal && (
                        <Typography className={css.total}>Total: {data.length}</Typography>
                    )}
                    <Pagination
                        className={css.pagination}
                        count={pagesCount}
                        page={currentPage}
                        onChange={(_, value: any) => {
                            setCurrentPage(value);
                        }}
                        variant="outlined"
                        shape="rounded"
                        hideNextButton
                        hidePrevButton
                    />
                </Box>
            )}
        </Box>
    );
};
